// CSS
import './App.less';
//BASIC REACT STUFF
import {createContext, useState} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

//LIBRARIES
import {ConfigProvider, Layout, App as AntdApp} from 'antd';
import type {MessageInstance} from 'antd/es/message/interface';

import JavascriptTimeAgo from 'javascript-time-ago';
import is from 'javascript-time-ago/locale/is';
import axios from 'axios';

// COMPONENTS
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

// REDUX
import store from './store';
import {Provider} from 'react-redux';

// PAGES
import Frontpage from './Pages/Frontpage/Frontpage';
import About from './Pages/About/About';
import Team from './Pages/Team/Team';
import TeamKit from './Pages/TeamKit/TeamKit';
import Session from './Pages/Session/Session';
import CreateEvent from './Pages/CreateEvent/CreateEvent';
import CreateTeam from './Pages/CreateTeam/CreateTeam';
import Profile from './Pages/Profile/Profile';
import PlayerDetails from './Pages/PlayerDetails/PlayerDetails';

import EventNotifications from './Pages/EventNotifications/EventNotifications';
import PayForUser from './components/PayForUser/PayForUser';

//LIBRARIES SETTINGS
JavascriptTimeAgo.addLocale(is);
axios.defaults.headers.common['x-csrftoken'] = (document.getElementsByName('csrfmiddlewaretoken')[0] as HTMLInputElement)?.value || '';

export default function App() {
    const user = window.me
        ? {
              id: window.me,
              uuid: window.my_uuid,
              plan: window.my_plan,
              signature_name: window.signature_name,
              image: window.user_image,
          }
        : null;

    const [payForUserModal, setPayForUserModal] = useState(false);
    const {message: messageApi} = AntdApp.useApp();
    return (
        <Provider store={store}>
            <Router>
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: '#7f00ff',
                        },
                    }}
                >
                    <AntdApp>
                        <Context.Provider
                            value={{
                                user,
                                setPayForUserModal,
                                messageApi: messageApi,
                            }}
                        >
                            <Layout>
                                <Header></Header>
                                <Layout id='mainContainer'>
                                    <Layout>
                                        <Routes>
                                            <Route path='/' element={<Frontpage />} />
                                            <Route path='/umokkur' element={<About />} />
                                            <Route path='/lid/:uuid' element={<Team />} />
                                            <Route path='/buningar/:uuid' element={<TeamKit />} />
                                            <Route path='/timi/:uuid' element={<Session />} />
                                            <Route path='/stillingar/' element={<Profile />} />
                                            <Route path='/leikmadur/:uuid' element={<PlayerDetails />} />
                                            <Route path='/nyttlid' element={<CreateTeam />} />
                                            <Route path='/stofna_vidburd/:uuid' element={<CreateEvent />} />
                                            <Route path='/aminningar/:uuid' element={<EventNotifications />} />
                                        </Routes>
                                    </Layout>
                                </Layout>

                                <Footer>
                                    <strong>vantaribolta.is</strong>- Hannað og forritað af{' '}
                                    <a href='https://repeat.is/' target='_blank' rel='noopener noreferrer'>
                                        Repeat.is
                                    </a>
                                </Footer>
                            </Layout>

                            <PayForUser
                                open={!!payForUserModal}
                                onCancel={() => {
                                    setPayForUserModal(false);
                                }}
                            ></PayForUser>
                        </Context.Provider>
                    </AntdApp>
                </ConfigProvider>
            </Router>
        </Provider>
    );
}

export const Context = createContext<{
    user: {
        id: number;
        uuid: string;
        plan: string;
    } | null;
    setPayForUserModal: (open: boolean) => void;
    messageApi: MessageInstance | null;
}>({
    user: null,
    setPayForUserModal: () => {},
    messageApi: null,
});
